import { split86012String } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';
import { ScheduleItemProps } from '../ScheduleDisplay';

type ScheduleDateType = ScheduleItemProps['data']['startTimeISO8601TZ'];

const formatTimeWithoutLeadingZero = (date: ScheduleDateType) => {
  if (!date) return null;

  const { datetime } = split86012String(date);
  return new Date(datetime).toLocaleTimeString('en-US', {
    hour: 'numeric', // Use 'numeric' instead of '2-digit' to avoid leading zeros
    minute: '2-digit',
  });
};

export const formatDateAsTimes = (startDate?: ScheduleDateType, endDate?: ScheduleDateType) => {
  if (!startDate) return 'TBA';

  if (!endDate) {
    return formatTimeWithoutLeadingZero(startDate); // Return only the start time
  }

  return `${formatTimeWithoutLeadingZero(startDate)} to ${formatTimeWithoutLeadingZero(endDate)}`; // Return start and end time
};

export const formatDateAsDay = (dayDate: ScheduleDateType) => {
  if (!dayDate) return null;
  const { datetime } = split86012String(dayDate);

  return new Date(datetime).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
